import { useLocalization } from "@shared-ui/localization-context";
import * as React from "react";
import { PackageInfoProps } from "components/flexComponents/Packages/typings";
import { UitkText } from "uitk-react-text";

const FlightInfo = ({ packageItem }: PackageInfoProps) => {
  const { formatText } = useLocalization();
  const flightType = `package.card.flight.${packageItem.nonStop ? "roundtripNonStopIncluded" : "roundtripIncluded"}`;
  const originDestination = "package.card.flight.tripOriginDestination";
  const originDestinationArgs = [
    packageItem.originCityName,
    packageItem.originAirport,
    packageItem.destinationCityName,
    packageItem.destinationAirport,
  ];

  return (
    <div className="flight-info">
      <UitkText overflow="truncate" size={300}>
        {formatText(flightType)}
      </UitkText>
      <UitkText overflow="truncate" size={300}>
        {formatText(originDestination, ...originDestinationArgs)}
      </UitkText>
    </div>
  );
};

export default FlightInfo;
